import React from "react"

import {FieldPickerProps} from "../../../render/picker"
import HintPopover from "../../../../gd-ui/hint-popover/hint-popover"

const debug = false
// const debug = "FieldDropdown_Picker"

export default class FieldDropdown_Picker extends React.Component<FieldPickerProps,any> {

    public previousValue        : any

    constructor(props:FieldPickerProps) {
        super(props);

        const value = _.get(props.model, props.field.fieldId, null)

        this.state = {
            initialPropsValue: value, // required to check if currentOption update needed on props changed
            currentValue: value,
            showPopover: false,
        }
    }

    static getDerivedStateFromProps(props:any, state:any) {
        const value = props.model[props.field.fieldId] // new value

        if (value !== state.initialPropsValue) {
            return {
                initialPropsValue   : value,
                currentValue       : props.field._getOption(value)?.value
            }
        }

        return null // no changes
    }

    showPopover = () => {if (!this.state.showPopover) this.setState({showPopover: true})}
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    // for compatibility with dropdown PopoverMenu (BaseDropdownPopoverMenu)
    onOptionClick = (option:any) => {this.onValueChange(option ? option.value : option)}

    onValueChange = (value:any) => {
        this.previousValue = this.state.currentValue;
        const newValue = value; //_.get(option, 'value', null);

        this.setState({
            currentValue: newValue
        }, () => {
            // if (this.props.onChange) this.props.onChange(newValue, this.onCancelChange);
            if (this.props.onChange) this.props.onChange(newValue);
            this.hidePopover()
        });
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        });
    }

    render() {

        const {field} = this.props;

        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        });

        debug && console.log(debug, 'render', !_.isNil(this.state.currentValue), this.state.currentValue)

        const showHint = _.get(this.props.configOptions, 'showHint', true)

        // need check value because of none
        if (!_.isNil(this.state.currentValue)) {
            return (
                <field.components.PickerValueNotEmpty {...this.props} className={classes} field={this.props.field} value={this.state.currentValue} onClick={this.showPopover} onChange={this.onValueChange}>
                    {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                    {!this.state.showPopover && showHint && <HintPopover hint={this.props.field.label}/>}
                </field.components.PickerValueNotEmpty>
            );
        }

        // no value
        return (
            <field.components.PickerValueEmpty {...this.props} className={classes} field={this.props.field} onClick={this.showPopover}>
                {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
                {!this.state.showPopover && showHint && <HintPopover hint={this.props.field.label}/>}
            </field.components.PickerValueEmpty>
        );

    }
}

